<section class="grouped-header">
  <h2 data-testid="erp-outbound-grouped-title">ERP Outbound Report — by Sales Order</h2>
  <button
    mat-icon-button
    data-testid="erp-outbound-grouped-refresh"
    aria-label="Refresh grid"
    (click)="refresh()">
    <mat-icon fontIcon="replay"/>
  </button>
</section>

@if (loading()) {
  <mat-progress-bar mode="indeterminate"/>
}

<table
  mat-table
  multiTemplateDataRows
  [dataSource]="groups()"
  class="grouped-table"
  data-testid="erp-outbound-grouped-table">

  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef aria-label="Expand"></th>
    <td mat-cell *matCellDef="let group">
      <button
        mat-icon-button
        aria-label="Toggle order actions"
        (click)="toggle(group); $event.stopPropagation()">
        <mat-icon>{{ isExpanded(group) ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="erpOrderNumber">
    <th mat-header-cell *matHeaderCellDef>ERP Sales Order No.</th>
    <td mat-cell *matCellDef="let group">
      <span class="order-no">{{ orderLabel(group) }}</span>
      @if (group.hasError) {
        <mat-icon class="error-flag" matTooltip="This order has an error">warning</mat-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="legalEntityName">
    <th mat-header-cell *matHeaderCellDef>Legal Entity</th>
    <td mat-cell *matCellDef="let group">{{ group.legalEntityName }}</td>
  </ng-container>

  <ng-container matColumnDef="pnr">
    <th mat-header-cell *matHeaderCellDef>PNR</th>
    <td mat-cell *matCellDef="let group">{{ group.pnr }}</td>
  </ng-container>

  <ng-container matColumnDef="actionCount">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let group">
      <span class="count-badge">{{ group.actionCount }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="latestResult">
    <th mat-header-cell *matHeaderCellDef>Latest Result</th>
    <td mat-cell *matCellDef="let group">
      <span class="chip" [ngStyle]="chipStyle(group.latestResult)">{{ group.latestResult }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="latestDateCreated">
    <th mat-header-cell *matHeaderCellDef>Latest Activity</th>
    <td mat-cell *matCellDef="let group">{{ group.latestDateCreated | date:'M/dd/yyyy HH:mm' }}</td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let group" [attr.colspan]="masterColumns.length">
      <div class="detail-wrapper" [class.expanded]="isExpanded(group)">
        <div class="detail-inner">
          <table class="actions-table">
            <thead>
              <tr>
                <th>Response Type</th>
                <th>Queue</th>
                <th>ERP Message ID</th>
                <th>ADX Invoice</th>
                <th>ERP Invoice No.</th>
                <th>Result</th>
                <th>Raw</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              @for (action of group.actions; track action.adxInvoiceErpResponseId) {
                <tr>
                  <td>{{ action.responseType }}</td>
                  <td>{{ action.queueName }}</td>
                  <td>{{ action.erpMessageId }}</td>
                  <td>
                    @if (action.adxInvoiceId) {
                      <a class="link" [href]="'AdxInvoices/' + action.adxInvoiceId" target="_blank">{{ action.adxInvoiceId }}</a>
                    }
                  </td>
                  <td>{{ action.invoiceNumber }}</td>
                  <td class="result-cell">
                    <span class="chip" [ngStyle]="chipStyle(action.result)">{{ action.result }}</span>
                    @if (isError(action)) {
                      <button
                        mat-icon-button
                        class="error-btn"
                        matTooltip="View error description"
                        aria-label="View error description"
                        (click)="openError(action)">
                        <mat-icon>warning</mat-icon>
                      </button>
                    }
                  </td>
                  <td>
                    @if (action.rawMessage) {
                      <a class="link" (click)="openRawMessage(action)">View</a>
                    }
                  </td>
                  <td>{{ action.dateCreated | date:'M/dd/yyyy HH:mm' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="masterColumns"></tr>
  <tr
    mat-row
    *matRowDef="let group; columns: masterColumns"
    class="master-row"
    [class.expanded-row]="isExpanded(group)"
    (click)="toggle(group)"></tr>
  <tr mat-row *matRowDef="let group; columns: ['expandedDetail']" class="detail-row"></tr>
</table>

@if (!loading() && !groups().length) {
  <p class="empty-state" data-testid="erp-outbound-grouped-empty">No results for the selected filters.</p>
}

<mat-paginator
  data-testid="erp-outbound-grouped-paginator"
  [length]="totalItemCount()"
  [pageSize]="pageSize()"
  [pageIndex]="pageIndex()"
  [pageSizeOptions]="[5, 15, 25, 50, 75, 100]"
  (page)="onPage($event)"/>
